<script>
import store from 'apps/bankrate-calculators/common/store'
import calcInput from 'apps/bankrate-calculators/components/number-input.vue'
import amortization from 'apps/bankrate-calculators/components/amortization'
import extraPayments from 'apps/bankrate-calculators/components/extra-payments'
import amortizationMixin from 'apps/bankrate-calculators/common/amortization-mixin'
import config from './config'

const template = store.state.isMobile
  ? require('./mobile-template.html')
  : require('./template.html')

export default {
  mixins: [amortizationMixin],
  template,
  store,
  components: { calcInput, amortization, extraPayments },
  data() {
    return { config: config }
  },
  created() {
    this.$store.dispatch('calculatorLoaded', config)
  }
}
</script>
